// Small date helpers for due-date display and the planning view.
// All parsing is done in local time from a 'YYYY-MM-DD' string.

export function parseDate(str) {
  if (!str) return null;
  const [y, m, d] = str.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

function startOfToday() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

// Whole days from today (negative = past). Null when no date.
export function daysFromToday(str) {
  const date = parseDate(str);
  if (!date) return null;
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  return Math.round((date - startOfToday()) / MS_PER_DAY);
}

// Short, human label: Today / Tomorrow / Yesterday / "Mon 18 Jun".
// `short` drops the weekday ("18 Jun") for tight spots like compact board cards.
export function formatDueDate(str, { short = false } = {}) {
  const date = parseDate(str);
  if (!date) return '';
  const diff = daysFromToday(str);
  if (diff === 0) return 'Today';
  if (diff === 1) return short ? 'Tmrw' : 'Tomorrow';
  if (diff === -1) return short ? 'Yday' : 'Yesterday';
  return date.toLocaleDateString(undefined, short
    ? { day: 'numeric', month: 'short' }
    : { weekday: 'short', day: 'numeric', month: 'short' });
}

// Urgency bucket for colouring a due-date chip (only meaningful for open tickets).
export function dueState(str) {
  const diff = daysFromToday(str);
  if (diff === null) return 'none';
  if (diff < 0) return 'overdue';
  if (diff === 0) return 'today';
  if (diff <= 3) return 'soon';
  return 'future';
}

// Planning buckets, in display order.
export const PLANNING_GROUPS = [
  { key: 'overdue', label: 'Overdue' },
  { key: 'today', label: 'Today' },
  { key: 'this_week', label: 'This week' },
  { key: 'next_week', label: 'Next week' },
  { key: 'later', label: 'Later' },
  { key: 'none', label: 'No due date' },
];

export function planningGroup(str) {
  const diff = daysFromToday(str);
  if (diff === null) return 'none';
  if (diff < 0) return 'overdue';
  if (diff === 0) return 'today';
  if (diff <= 7) return 'this_week';
  if (diff <= 14) return 'next_week';
  return 'later';
}
